

// DEPRECATED
console.warn('`promise-util` module is deprecated, '
			+ 'please use `q`, `promise-queue` or `single-promise-queue` instead');

module.exports = {
	toJQuery: require('./js/coerce-to-jquery.js'),
	PromiseQueue: require('./js/promise-queue.js'),
	SinglePromiseQueue: require('./js/single-promise-queue.js'),
};

